import {
    Divider,
    Drawer,
    DrawerCloseButton,
    DrawerContent,
    DrawerOverlay,
    Stack
} from "@chakra-ui/react";
import Sidebar from "../../pages/Sidebar";
import {useNav} from "../../context";

export default function MobileSidebar() {
    const p = useNav();
    return <Drawer
        isOpen={p.isOpen}
        onClose={p.onClose}
        placement="left"
        trapFocus
    >
        <DrawerOverlay />
        <DrawerContent layerStyle="neutral" data-testid="drawer">
            <DrawerCloseButton position="absolute" insetBlockStart={"16px"} insetInlineEnd="16px" />
            <Stack spacing={2} fontSize="sm">
                <Sidebar/>
                <Divider />
            </Stack>
        </DrawerContent>
    </Drawer>;
};

